import * as yup from 'yup';
import { PartnersEnum } from 'entities/Partners/enums';
import { AutoconnectByLabelsEnum } from 'entities/CustomModel/types';

const isEmpty = (v: any) => v === undefined || v === '';

export const settingsSchema = yup.object({
	name: yup.string().required('shared_texts.field_is_required'),
	settings: yup.object({
		partnerType: yup.mixed<PartnersEnum>().oneOf(Object.values(PartnersEnum)),
		autoconnectByLabels: yup
			.array()
			.of(yup.mixed<AutoconnectByLabelsEnum>().oneOf(Object.values(AutoconnectByLabelsEnum)))
			.test('autoconnectByLabels', 'custom_model.settings.partners_priority', function (value) {
				if (!Array.isArray(value)) return false;
				const allEmpty = value.every(isEmpty);
				if (allEmpty) return true;
				const firstEmptyIndex = value.findIndex(isEmpty);
				if (firstEmptyIndex === -1) return true;
				const hasFilledAfterEmpty = value.slice(firstEmptyIndex).some((v) => !isEmpty(v));

				return !hasFilledAfterEmpty;
			}),
		splitUploadedDoc: yup.bool(),
		sendEmailOnPartnerAssociationFailure: yup.bool(),
		sendEmailOnItemCodeNotFound: yup.bool(),
		sendEmailOnSuccessExport: yup.bool(),
		sendEmailOnReceiverIdNotFound: yup.bool(),
		pagesRange: yup.string().matches(/^\d+(-\d+)?(,\d+(-\d+)?)*$/, 'files.default_import.validation'),

		ftpImport: yup.object({
			autoImportInterval: yup.string(),
			path: yup.string(),
			autoImportDeleteAfter: yup.bool(),
		}),
		ftpExport: yup.object({
			autoExportFormat: yup.string(),
			path: yup.string(),
			originalFilePath: yup.string(),
			compressOriginalFile: yup.bool(),
		}),
	}),
});

export type SettingsSchemaType = yup.InferType<typeof settingsSchema>;
